/*
  クイズの答えの段落を、開くまで見えない囲み (directive-quizanswer) に包む (MarkdownContent の foldQuizAnswers を付けたときだけ通す)。

  本文の形は次の通り。選択肢が A から D の箇条書きで、直後の段落が「答えは B の UDP です。…」で始まる。
  そのままだと、考える前に答えが読める。本文の markdown は書き換えず、描くときの木だけを組み直す。
  選択肢の箇条書きは、項目がすべて A から E (または ア から エ) の記号で始まる列だけを対象にする。
  普通の箇条書きのあとの「答えは」の段落には触らない。
*/
type Node = { type: string; value?: string; ordered?: boolean | null; children?: Node[]; data?: Record<string, unknown> };

const CHOICE = /^\s*[A-EＡ-Ｅア-オ][\s.．)）、:：]/;
const ANSWER = /^\s*答え\s*(?:は|[:：])/;

function textOf(node: Node | undefined): string {
  if (!node) return "";
  if (typeof node.value === "string") return node.value;
  return (node.children ?? []).map(textOf).join("");
}

/** 項目がすべて選択肢の記号で始まる、2 つ以上の箇条書きか */
function isChoiceList(node: Node | undefined): boolean {
  if (node?.type !== "list") return false;
  const items = node.children ?? [];
  return items.length >= 2 && items.every((item) => CHOICE.test(textOf(item)));
}

function fold(parent: Node): void {
  const kids = parent.children;
  if (!kids) return;
  for (let i = 0; i < kids.length; i++) {
    const node = kids[i];
    if (node.type === "paragraph" && ANSWER.test(textOf(node)) && isChoiceList(kids[i - 1])) {
      kids[i] = {
        type: "quizAnswer",
        data: { hName: "directive-quizanswer", hProperties: {} },
        children: [node],
      };
      continue;
    }
    fold(node);
  }
}

export function remarkQuizAnswers() {
  return (tree: Node) => fold(tree);
}
